<template>
  <div class="main-wrapper nft-font-familly">
    <div class="nft-header">
      <nft-header :config="headerConfig"></nft-header>
    </div>
    <div class="body-container nft-body-container" :style="{ paddingTop: headerConfig.paddingTop + 'px' }">
      <ClientCommon />
      <slot />
    </div>
    <nft-footer />
    <VerificationLimitDIalog />
    <KycCountryLimitDialog />
    <!-- <MFAVerificationStepDialog :visible="mfaVerifyNoticeVisible" @update:visible="changeMfaVerifyNoticeVisible" /> -->
    <Verify />
    <DepositGuide />
    <!-- <client-only>
      <AiChat />
    </client-only> -->
  </div>
</template>
<script>
import { debounce } from 'lodash-es';
import NftFooter from '~/components/global/NftFooter.vue';
import NftHeader from '~/components/global/NftHeader.vue';
import VerificationLimitDIalog from '~/components/global/VerificationLimitDIalog.vue';
import KycCountryLimitDialog from '~/components/global/KycCountryLimitDialog.vue';
// import MFAVerificationStepDialog from '~/components/global/MFAVerificationStepDialog/index'
import Verify from '~/frontend-shared/components/Verify/index.vue';
import DepositGuide from '~/frontend-shared/components/DepositGuide/index.vue';

import ClientCommon from '~/components/ClientCommon.vue';
import { mapState, usePatchStore } from '~/common/js/patch';
import { isLoginedToken } from '~/common/js/utils';
import { head } from '~/common/js/baseLayout';
// aiChat
import AiChat from '~/frontend-shared/components/aiChat/index.vue';
// import { events } from '~/utils/track'
const WHITE_HEAD = 'white';
// const TRANSPARENT_WHITE_HEAD = 'transparent-white'
const TRANSPARENT_BLACK_HEAD = 'transparent-black';
// const ICON_MENU_COLOR_WHITE = '#fff'
const ICON_MENU_COLOR_BLACK = '#0e1118';
export default {
  head,
  components: {
    NftHeader,
    NftFooter,
    VerificationLimitDIalog,
    // MfaVerifyNotice,
    // MFAVerificationStepDialog,
    Verify,
    ClientCommon,
    DepositGuide,
    KycCountryLimitDialog,
    AiChat,
  },
  data() {
    return {
      // 导航栏是否吸顶
      hasHeaderTurn: false,
      inApp: false, // 用来隐藏退登和注册按钮，app内使用
      hasCheckApp: false,
    };
  },
  computed: {
    headerConfig() {
      const { name } = this.$route;
      console.log('name >>', name);
      const defaultConfig = {
        theme: WHITE_HEAD,
        turnHeight: 80,
        paddingTop: 80,
        menuColor: ICON_MENU_COLOR_BLACK,
      };
      // web容器安全头部高度
      let sat = 0;
      if (process.client) {
        sat = getComputedStyle(document.documentElement).getPropertyValue('--sat');
      }

      const appConfig = {
        theme: WHITE_HEAD,
        turnHeight: parseInt(sat) + 56 + 32, // 56是导航条高度，32是下边距
        paddingTop: parseInt(sat) + 56 + 32,
        menuColor: ICON_MENU_COLOR_BLACK,
      };
      const pageConfigMap = new Map([
        // // 首页
        // [
        //   'nft-lang-home',
        //   {
        //     theme: TRANSPARENT_WHITE_HEAD,
        //     paddingTop: 0,
        //     menuColor: ICON_MENU_COLOR_WHITE,
        //   },
        // ],
        // 个人中心页
        [
          'nft-usercenter-lang',
          {
            theme: TRANSPARENT_BLACK_HEAD,
            paddingTop: 0,
            turnHeight: 10,
          },
        ],
      ]);

      const useConfig = this.inApp ? appConfig : defaultConfig;
      // 将页面配置和初始配置合并出当前的配置
      const currConfig = pageConfigMap.get(name) ? { ...useConfig, ...pageConfigMap.get(name) } : useConfig;
      // 如果是吸顶
      if (this.hasHeaderTurn) {
        return { ...useConfig, paddingTop: currConfig.paddingTop, turnHeight: currConfig.turnHeight };
      }
      return currConfig;
    },
    ...mapState({
      mfaVerifyNoticeVisible: (state) => state.mfaVerifyNoticeVisible,
      locale: (state) => state.locale,
    }),
  },
  mounted() {
    if (window.jsBridge) {
      this.inApp = true;
      this.hasCheckApp = true;
    }
    const launched = +sessionStorage.getItem?.('launched');
    if (isLoginedToken() && !launched) {
      // this.$riskTrack({ event_id: events.APP_LAUNCH })
      sessionStorage.setItem?.('launched', '1');
    }
    window.addEventListener('scroll', this.handleScroll, false);

    if (window.zE) {
      // window.zE && window.zE('webWidget', 'show')
    } else {
      const script = document.createElement('script');
      script.id = 'ze-snippet';
      script.src = 'https://static.zdassets.com/ekr/snippet.js?key=03a84f92-0fab-4cd7-8e75-b9c1cb2ce992';
      script.defer = true;
      document.body.appendChild(script);
      script.onload = () => {
        this.changeChatLang(this.locale);
      };
      // window.zESettings = {
      //   webWidget: {
      //     offset: {
      //       vertical: '0px',
      //       mobile: {
      //         vertical: '50px',
      //       },
      //     },
      //   },
      // }
    }
  },
  methods: {
    changeChatLang(lang) {
      console.log('changeChatLang', lang);
      let chatLang = 'en';
      if (lang === 'cn') {
        chatLang = 'zh';
      } else if (lang === 'tr') {
        chatLang = 'tr';
      } else if (lang === 'kr') {
        chatLang = 'ko';
      } else if (lang === 'jp') {
        chatLang = 'ja';
      } else if (lang === 'vn') {
        chatLang = 'vi';
      } else if (lang === 'cn_tw') {
        chatLang = 'zh_tw';
      } else if (lang === 'ru') {
        chatLang = 'ru';
      }
      // window.zE && window.zE('webWidget', 'setLocale', chatLang)
      window.zE && window.zE('messenger:set', 'locale', chatLang);
    },
    changeMfaVerifyNoticeVisible() {
      this.store.commit('HIDE_MFA_VERIFY_NOTICE_VISIBLE');
    },
    // 页面滚动事件
    handleScroll: debounce(function () {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.hasHeaderTurn = scrollTop > this.headerConfig.turnHeight;
    }, 10),
  },
  watch: {
    '$route.params.lang'(to, from) {
      this.changeChatLang(to);
    },
  },
  setup() {
    const { store } = usePatchStore();
    return {
      store,
    };
  },
};
</script>
<style lang="less" scoped>
.main-wrapper {
  .nft-header {
    position: fixed;
    width: 100%;
    z-index: 100;
  }
  .body-container {
    background: #fff;
  }
}
</style>
<style>
:root {
  --sat: env(safe-area-inset-top);
}
.nft-font-familly {
  font-family:
    IBM,
    Helvetica Neue,
    Helvetica,
    PingFang SC,
    Hiragino Sans GB,
    Microsoft YaHei,
    微软雅黑,
    Arial,
    sans-serif !important;
}
</style>
